var React = require('react');

function ScalaPlain (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"matrix(.067665 0 0 .067665 17.968 -3.2402)","fill":"#ff4d4f"},[React.createElement("path",{"d":"m110 1682v-229l175-7c182-7 317-22 515-56 225-39 447-109 470-149 6-10 10 67 10 216v232l-26 20c-28 22-136 59-259 90-192 48-661 111-821 111h-64z","key":0}),React.createElement("path",{"d":"m110 1102v-229l175-6c194-8 345-25 545-62 224-42 428-110 443-147 3-7 6 90 6 216 1 200-1 232-16 248-35 39-305 109-583 152-169 26-449 56-527 56h-43z","key":1}),React.createElement("path",{"d":"m110 526v-224l31-6c17-3 59-6 93-6 168 0 567-55 763-105 137-36 232-72 265-102 17-15 18-6 18 214 0 215-1 231-19 247-27 25-212 82-356 111-233 46-620 95-752 95h-43z","key":2})]));
}

ScalaPlain.defaultProps = {"version":"1.0","viewBox":"0 0 128 128"};

module.exports = ScalaPlain;

ScalaPlain.default = ScalaPlain;
